import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-riFill-mail-add-fill",
  "use": "icon-riFill-mail-add-fill-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-riFill-mail-add-fill\">\n\n  <g>\n    <path d=\"M29.333 17.788c-0.795-0.291-1.714-0.459-2.671-0.459-4.418 0-8 3.582-8 8 0 0.958 0.168 1.876 0.477 2.727l-0.018-0.056h-15.121c-0.736 0-1.333-0.597-1.333-1.333v0-21.333c0-0.736 0.597-1.333 1.333-1.333v0h24c0.736 0 1.333 0.597 1.333 1.333v0 12.455zM16.080 15.577l-8.549-7.26-1.727 2.032 10.293 8.74 10.108-8.747-1.744-2.017-8.38 7.252zM28 24h4v2.667h-4v4h-2.667v-4h-4v-2.667h4v-4h2.667v4z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol